<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: [Object, Array, String], default: null },
  accept: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  rules: { type: Array, default: () => [] }
})
const emit = defineEmits(['update:modelValue'])
const files = computed({
  get: () => props.modelValue,
  set: (value) => {
    const selected = Array.isArray(value) ? value : value ? [value] : []
    emit('update:modelValue', props.multiple ? selected : selected[0] ?? null)
  }
})
</script>

<template>
  <v-file-input
    v-model="files"
    :accept="accept"
    :multiple="multiple"
    :disabled="disabled"
    :label="label"
    :rules="rules"
    :chips="multiple"
    :counter="multiple"
    append-inner-icon="mdi-tray-arrow-up"
    class="attachment-file-picker"
    prepend-icon=""
  />
</template>

<style scoped>
.attachment-file-picker :deep(.v-field) {
  min-height: 56px;
}
</style>
